module.exports = __webpack_public_path__ + "img/4-6.7ab974b2.png";